<template>
  <v-snackbar
    v-model="snackbar.open"
    :color="snackbar.colorSnackbar"
    :timeout="3000"
    :top="true"
    :vertical="true"
  >
    {{ snackbar.textSnackbar }}

    <template v-slot:action="{ attrs }">
      <v-btn
        id="btn-close"
        dark
        text
        v-bind="attrs"
        @click="snackbar.open = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackbarQueues',
  props: {
    snackbar: Object
  }
}
</script>
